import axiosInstance from '../../../../config/axiosInstance';
const  DateFormatService = {
    async GetActiveDateFormat(redirectCallback) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetActiveDateFormat?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async GetAll(redirectCallback) {
        try {            
            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetAll?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async SetDateFormat(redirectCallback,ID) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/SetDateFormat?ClientID=${ClientID}&ID=${ID}`);
            return response.data;
        } catch (error) {
            
            console.error('Error fetching roles:', error);
            throw error;
        }
    }
};

export default DateFormatService;